import { render, staticRenderFns } from "./QuitaCreate.vue?vue&type=template&id=e10e6afa&scoped=true"
import script from "./QuitaCreate.vue?vue&type=script&lang=js"
export * from "./QuitaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10e6afa",
  null
  
)

export default component.exports